import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import { Observable } from 'rxjs/Observable';
import swal from 'sweetalert2';
import * as _ from 'lodash';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import { HamodelService, CommonService, SeriesService,PowerService,PerformanceService,DesignService,BatteryService,HaModelColorService } from '../../../services/index';

@Component({
    selector: 'add-edit-ha-model-window',
    templateUrl: './addEditHamodel.component.html'
})
export class AddEditHamodelComponent implements OnInit {
    public title: string;
    public mode: string;
    public list: any[] = [];
    public hamodeldata: any[] = [];
    filteredBrandModel: Observable<any[]>;
    filteredBrand: Observable<any[]>;
    filteredFamily: Observable<any[]>;
    filteredSeries: Observable<any[]>;
    filteredPower: Observable<any[]>;
    filteredPerformance: Observable<any[]>;
    filteredDesign: Observable<any[]>;
    filteredBattery: Observable<any[]>;
    //itemList: any[] = [];
    brandModelList$: any[] = [];
    brandModelCtrl: FormControl;
    brandList$: any[] = [];
    brandCtrl: FormControl;
    familyList$: any[] = [];
    seriesList$: any[] = [];
    powerList$: any[] = [];
    performanceList$: any[] = [];
    designList$: any[] = [];
    batteryList$: any[] = [];
    warrantyList: any = [];
    warrantyPeriodCtrl: FormControl;
    familyCtrl: FormControl;
    seriesCtrl: FormControl;
    powerCtrl: FormControl;
    performanceCtrl: FormControl;
    designCtrl: FormControl;
    batteryCtrl: FormControl;
    teleAudiologyCtrl: FormControl;
    teleAudiologyList: string[] = ['Yes', 'No'];
    haModelColorList: any[] = [];
    @Output() haModelLoadEvent = new EventEmitter();
  
    // trigger-variable for Ladda
    isLoading: boolean = false;

    constructor(public store: Store<fromRootStore.State>, private hamodelService: HamodelService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService, private commonService: CommonService, private seriesService: SeriesService, private powerService: PowerService, private performanceService: PerformanceService, private designService: DesignService, private batteryService: BatteryService, private haModelColorService: HaModelColorService) {
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidBrandModel(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBrandModel: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBrandModel: true };
            }
            return retVal;
        }
        this.brandModelCtrl = new FormControl('', [
            Validators.required,
            hasValidBrandModel.bind(this)
        ]);
        this.filteredBrandModel = this.brandModelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrandModel(name) : this.brandModelList$.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND COMBO
        function hasValidBrand(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidBrand: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidBrand: true };
            }
            return retVal;
        }
        this.brandCtrl = new FormControl('', [
            Validators.required,
            hasValidBrand.bind(this)
        ]);
        this.filteredBrand = this.brandCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrand(name) : this.brandList$.slice());
        //FOR AUTO COMPLETE VALIDATION --- FAMILY COMBO
        function hasValidFamily(input: FormControl) {
            let familyID = input.value, retVal = null;
            if (familyID == "") {
                retVal = { inValidFamily: true };
            }
            if (familyID && typeof familyID === 'string') {
                retVal = { inValidFamily: true };
            }
            return retVal;
        }
        this.familyCtrl = new FormControl('', [
            Validators.required,
            hasValidFamily.bind(this)
        ]);
        function hasValidSeries(input: FormControl) {
            let seriesID = input.value, retVal = null;
            if (seriesID && typeof seriesID === 'string') {
                retVal = { inValidSeries: true };
            }
            return retVal;
        }
        this.seriesCtrl = new FormControl('', hasValidSeries.bind(this));
        function hasValidPower(input: FormControl) {
            let powerID = input.value, retVal = null;
            if (powerID && typeof powerID === 'string') {
                retVal = { inValidPower: true };
            }
            return retVal;
        }
        this.powerCtrl = new FormControl('', hasValidPower.bind(this));
        function hasValidPerformance(input: FormControl) {
            let performanceID = input.value, retVal = null;
            if (performanceID && typeof performanceID === 'string') {
                retVal = { inValidPerformance: true };
            }
            return retVal;
        }
        this.performanceCtrl = new FormControl('', hasValidPerformance.bind(this));
        function hasValidDesign(input: FormControl) {
            let designID = input.value, retVal = null;
            if (designID && typeof designID === 'string') {
                retVal = { inValidDesign: true };
            }
            return retVal;
        }
        this.designCtrl = new FormControl('', hasValidDesign.bind(this));
        function hasValidBattery(input: FormControl) {
            let batteryID = input.value, retVal = null;
            if (batteryID && typeof batteryID === 'string') {
                retVal = { inValidBattery: true };
            }
            return retVal;
        }
        this.batteryCtrl = new FormControl('', hasValidBattery.bind(this));

        //FOR TELE AUDIOLOGY VALIDATION
        function hasValidTeleAudiology(input: FormControl) {
            let val = input.value, retVal = null;
            if (val !== 'Yes' && val !== 'No') {
                retVal = { inValidTeleAudiology: true };
            }
            return retVal;
        }
        this.teleAudiologyCtrl = new FormControl('', [
            Validators.required,
            hasValidTeleAudiology.bind(this)
        ]);

        this.filteredFamily = this.familyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterFamily(name) : this.familyList$.slice());

        this.filteredSeries = this.seriesCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSeries(name) : this.seriesList$.slice());

        this.filteredPower = this.powerCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPower(name) : this.powerList$.slice());

        this.filteredPerformance = this.performanceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPerformance(name) : this.performanceList$.slice());

        this.filteredDesign = this.designCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterDesign(name) : this.designList$.slice());

        this.filteredBattery = this.batteryCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBattery(name) : this.batteryList$.slice());
        
        //For Warranty Period
        function hasValidWarrantyType(input: FormControl) {
            let val = input.value, retVal = null;
            if (val != "1 Year" && val !="2 Years" && val !="2.5 Years"){
                retVal = { invalidType: true};
            }
            return retVal;
        }
        this.warrantyPeriodCtrl = new FormControl('', [
            Validators.required,
            hasValidWarrantyType.bind(this)
        ]);
    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#ha_model_name').focus();
        }, 100);
        // this.loadFamilyList();
        // this.loadAllList();
        this.warrantyList = ['1 Year', '2 Years', '2.5 Years'];
        this.haModelColorService.getActiveHaModelColorList().then((res: any) => {
            this.haModelColorList = res.data || [];
        });
        this.store.select(fromCommonStore.getAllBrandModel).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList$ = res;
                return;
            }
            this.brandModelList$ = res;
        });
        this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandList$ = res;
                return;
            }
            this.brandList$ = res;
        });
    }

    loadFamilyList() {
        let that = this;
        this.commonService
            .getFamilyList()
            .then(function(res: any) {
                // that.familyList$ = res.data;
                const familydata = res.data.filter(item => item.brand_id === that.hamodeldata['brand_id']);
                that.familyList$ = familydata;
                that.familyCtrl.setValue(that.hamodeldata['family_id']);
                // Set Tele Audiology value
                that.teleAudiologyCtrl.setValue(that.hamodeldata['tele_audiology']);
            });
    }

    onChangeFamily(){
        this.loadFamilyList();
        this.loadAllList();
    }

    loadAllList() {
        let that = this;
        //to get series list
        this.commonService
            .getAllList()
            .then(function(res: any) {
                const seriesdata = res.data.filter(item => item.brand_id === that.hamodeldata['brand_id']);
                that.seriesList$ = seriesdata;
                that.seriesCtrl.setValue(that.hamodeldata['series_id']);

                const powerdata = res.powerdata.filter(item => item.brand_id === that.hamodeldata['brand_id']);
                that.powerList$ = powerdata;
                that.powerCtrl.setValue(that.hamodeldata['power_id']);

                const performancedata = res.performancedata.filter(item => item.brand_id === that.hamodeldata['brand_id']);
                that.performanceList$ = performancedata;
                that.performanceCtrl.setValue(that.hamodeldata['performance_id']);

                // const batterydata = res.batterydata.filter(item => item.brand_id === that.hamodeldata['brand_id']);
                that.batteryList$ = res.batterydata;
                that.batteryCtrl.setValue(that.hamodeldata['battery_id']);

                that.designList$ = res.designdata;
                that.designCtrl.setValue(that.hamodeldata['design_id']);

                // Set Tele Audiology value
                that.teleAudiologyCtrl.setValue(that.hamodeldata['tele_audiology']);
            });
    }



    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    //BRAND MODEL
    filterBrandModel(name: string) {
        name = _.escapeRegExp(name);
        return this.brandModelList$.filter(item => (new RegExp(name, 'gi').test(item.disp_name)));
    }
    displayFn(modelID: number) {
        if (modelID && this.brandModelList$.length > 0) {
            let fitem = _.find(this.brandModelList$, { 'model_id': modelID });
            this.hamodeldata['disp_name'] = fitem['disp_name'];
            return fitem['disp_name'];
        }
        return '';
    }
    //BRAND
    filterBrand(name: string) {
        name = _.escapeRegExp(name);
        return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayBrandFn(brandID: number) {
        if (brandID && this.brandList$.length > 0) {
            let fitem = _.find(this.brandList$, { 'brand_id': brandID });
            this.hamodeldata['name'] = fitem['name'];
            return fitem['name'];
        }
        return '';
    }
    //FAMILY
    filterFamily(name: string) {
        name = _.escapeRegExp(name);
        return this.familyList$.filter(item => (new RegExp(name, 'gi').test(item.family_name)));
    }
    displayFamilyFn(familyID: number) {
        if (familyID && this.familyList$.length > 0) {
            let fitem = _.find(this.familyList$, { 'family_id': familyID });
            return fitem['family_name'];
        }
        return '';
    }

     //Power
     filterPower(name: string) {
        name = _.escapeRegExp(name);
        return this.powerList$.filter(item => (new RegExp(name, 'gi').test(item.power_name)));
    }
    displayPowerFn(powerID: number) {
        if (powerID && this.powerList$.length > 0) {
            let poweritem = _.find(this.powerList$, { 'power_id': powerID });
            return poweritem['power_name'];
        }
        return '';
    }

     //Performance
     filterPerformance(name: string) {
        name = _.escapeRegExp(name);
        return this.performanceList$.filter(item => (new RegExp(name, 'gi').test(item.performance_name)));
    }
    displayPerformanceFn(performanceID: number) {
        if (performanceID && this.performanceList$.length > 0) {
            let performanceitem = _.find(this.performanceList$, { 'performance_id': performanceID });
            return performanceitem['performance_name'];
        }
        return '';
    }

     //design
     filterDesign(name: string) {
        name = _.escapeRegExp(name);
        return this.designList$.filter(item => (new RegExp(name, 'gi').test(item.design_name)));
    }
    displayDesignFn(designID: number) {
        if (designID && this.designList$.length > 0) {
            let designitem = _.find(this.designList$, { 'design_id': designID });
            return designitem['design_name'];
        }
        return '';
    }

     //Battery
     filterBattery(name: string) {
        name = _.escapeRegExp(name);
        return this.batteryList$.filter(item => (new RegExp(name, 'gi').test(item.battery_name)));
    }
    displayBatteryFn(batteryID: number) {
        if (batteryID && this.batteryList$.length > 0) {
            let batteryitem = _.find(this.batteryList$, { 'battery_id': batteryID });
            return batteryitem['battery_name'];
        }
        return '';
    }

     //Series
     filterSeries(name: string) {
        name = _.escapeRegExp(name);
        return this.seriesList$.filter(item => (new RegExp(name, 'gi').test(item.series_name)));
    }
    displaySeriesFn(seriesID: number) {
        if (seriesID && this.seriesList$.length > 0) {
            let seriesitem = _.find(this.seriesList$, { 'series_id': seriesID });
            return seriesitem['series_name'];
        }
        return '';
    }

    onChangeModel(){

        // this.onChangeFamily();

        let branditem = _.find(this.brandList$, { 'brand_id': this.hamodeldata['brand_id'] });
        if(branditem==undefined){
            this.hamodeldata['name'] = undefined;
        } else {
            this.hamodeldata['name'] = branditem['name'];
        }

        let brandModelitem = _.find(this.brandModelList$, { 'model_id': this.hamodeldata['brand_model_id'] });
        if(brandModelitem==undefined){
            this.hamodeldata['disp_name'] = undefined;
        } else {
            this.hamodeldata['disp_name'] = brandModelitem['disp_name'];
        }

        let fitem = _.find(this.familyList$, { 'family_id': this.hamodeldata['family_id'] });
        if(fitem==undefined){
            this.hamodeldata['family_name'] = undefined;
        } else {
            this.hamodeldata['family_name'] = fitem['family_name'];
        }

        let seriesitem = _.find(this.seriesList$, { 'series_id': this.hamodeldata['series_id'] });
        if(seriesitem==undefined){
            this.hamodeldata['series_name'] = undefined;
        } else {
            this.hamodeldata['series_name'] = seriesitem['series_name'];
        }

        let performanceitem = _.find(this.performanceList$, { 'performance_id': this.hamodeldata['performance_id'] });
        if(performanceitem==undefined){
            this.hamodeldata['performance_name'] = undefined;
        } else {
            this.hamodeldata['performance_name'] = performanceitem['performance_name'];
        }

        let poweritem = _.find(this.powerList$, { 'power_id': this.hamodeldata['power_id'] });
        if(poweritem==undefined){
            this.hamodeldata['power_name'] = undefined;
        } else {
            this.hamodeldata['power_name'] = poweritem['power_name'];
        }

        let batteryitem = _.find(this.batteryList$, { 'battery_id': this.hamodeldata['battery_id'] });
        if(batteryitem==undefined){
            this.hamodeldata['battery_name'] = undefined;
        } else {
            this.hamodeldata['battery_name'] = batteryitem['battery_name'];
        }

        let model_list = this.hamodeldata['name'] + ' ' + this.hamodeldata['disp_name'] + ' ' + this.hamodeldata['family_name'] + ' ' + this.hamodeldata['series_name'] + ' ' + this.hamodeldata['performance_name'] + ' ' + this.hamodeldata['power_name'] + ' ' + this.hamodeldata['battery_name'];
        let cleanedString = model_list.replace(/\bundefined\b/g, '').replace(/\s+/g, ' ');
        this.hamodeldata['model_name'] = cleanedString;
        console.log("model name :", model_list);
    }

    onSaveHamodel(): void {
        let that = this,
            toast = {
                type: 'warning',
                title: 'WARNING'
            },
            
            data = {
                name: this.hamodeldata['model_name'],
                model_id: this.hamodeldata['model_id'],
                mrp: this.hamodeldata['mrp'],
                brand_model_id: this.hamodeldata['brand_model_id'],
                from_page: this.hamodeldata['from_page'],
                mode: this.hamodeldata['mode'],
                brand_id: this.hamodeldata['brand_id'],
                family_id: this.hamodeldata['family_id'],
                tax_per: this.hamodeldata['tax_per'],
                is_charger: this.hamodeldata['is_charger'] ? this.hamodeldata['is_charger'] : false,
                warranty_type :this.hamodeldata['warranty_type'],
                series_id : this.hamodeldata['series_id'],
                power_id : this.hamodeldata['power_id'],
                performance_id : this.hamodeldata['performance_id'],
                design_id : this.hamodeldata['design_id'],
                battery_id : this.hamodeldata['battery_id'],
                tele_audiology: this.hamodeldata['tele_audiology'] || 'No',
                color_id: this.hamodeldata['color_id'] || ''
            };
        this.isLoading = true;
        this.hamodelService
            .addUpdateHamodel(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.haModelLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/hamodel/addEditHamodel.component.ts